var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIXWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.526,
    height: 16.526,
    viewBox: "0 0 16.526 16.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3442",
    "data-name": "\\uADF8\\uB8F9 3442",
    transform: "translate(164.18 -1255.246) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_269",
    "data-name": "\\uC120 269",
    x2: 19.371,
    transform: "translate(773.5 1003.686)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_270",
    "data-name": "\\uC120 270",
    x2: 19.371,
    transform: "translate(783.186 994) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIXWhite);
export default __webpack_public_path__ + "static/media/I_xWhite.c9aa4d9e5cde5a4920994223ee9ca975.svg";
export { ForwardRef as ReactComponent };